__turbopack_context__.v({
  "phone-section": "phone-section-module-scss-module__O_ABKG__phone-section",
  "phone-section__header": "phone-section-module-scss-module__O_ABKG__phone-section__header",
  "phone-section__header-title": "phone-section-module-scss-module__O_ABKG__phone-section__header-title",
  "phone-section__input-container": "phone-section-module-scss-module__O_ABKG__phone-section__input-container",
  "phone-section__phone-type-input-container": "phone-section-module-scss-module__O_ABKG__phone-section__phone-type-input-container",
  "phone-section__remove-button": "phone-section-module-scss-module__O_ABKG__phone-section__remove-button",
});
